/* app/js/src/components/destinations/destination-settings/destination-settings-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.destination-settings-panel__save-row .button.apply {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.destination-settings-panel__save-row .button.apply:focus {
  outline-color: #ffffff;
}
.destination-settings-panel__save-row .button.apply:hover {
  background-color: white;
  color: #232f3a;
}
.destination-settings-panel__save-row .disabled.button.apply {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.destination-settings-panel__save-row .button.apply {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.destination-settings-panel__save-row .button.apply:focus {
  outline-color: #ffffff;
}
.destination-settings-panel__save-row .button.apply:hover {
  background-color: white;
  color: #232f3a;
}
.destination-settings-panel__save-row .disabled.button.apply {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
.destination-settings-panel__save-row {
  padding: 1rem 0 0.5rem 2.25rem;
}
.destination-settings-panel__save-row .button.apply {
  font-size: 11px;
  width: auto;
  height: 30px;
  padding: 6px 17px;
  margin-left: 0;
  cursor: pointer;
}
.destination-settings-panel__save-row .button.apply.disabled {
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
.destination-settings-panel__status {
  margin: 0;
  padding: 1rem 0 0.5rem 2.25rem;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.54);
}
.destination-settings-panel__status--error {
  color: #ef5350;
}
/*# sourceMappingURL=destination-settings-panel.component.css.map */
